<!-- splash screen -->
<div #splashScreen id="splash-screen">
  <img src="./assets/media/logos/Datacanva_Logo.webp" alt="Logo" style="width: 300px"/>
  <svg class="splash-spinner" viewBox="0 0 50 50">
    <circle id="spinner-circle" cx="25" cy="25" r="20"></circle>
  </svg>
</div>
